import classNames from 'classnames'
import React, { PureComponent } from 'react'

import { ENDPOINT } from '../../../../environment'
import { getImageByResolution, isBlank, isPresent } from '../../../shared'
import { ImageSource } from '../../../shared/model'

import './user-avatar.scss'

export type Props = {
  imageSource: ImageSource
  userName: string
  avatarSize?: number
  className?: string
  inline?: boolean
}

export type State = {
  hasImage: boolean
  imageUrl: string // which image url 'maybe' fail
  initials: string
}

export const AvatarSizes = {
  COMMENT: 18,
  BUTTON: 22,
  LIST: 34,
  CARD: 48,
  PROFILE: 144,
}

export const getUserInitials = (userName: string) => {
  if (!isPresent(userName)) return ''

  const firstLetters = userName
    .split(' ')
    .filter((word) => word !== '')
    .map((word) => word.charAt(0))

  const initials =
    firstLetters.length === 1 ? `${firstLetters[0]}` : `${firstLetters[0]}${firstLetters[firstLetters.length - 1]}`

  return initials.toUpperCase()
}

const NO_IMAGE = `${ENDPOINT}/no-image`

const getImageUrl = (imageSource: ImageSource): string | null => {
  // just the defense against emtpy object
  if (isBlank(imageSource.lowRes) && isBlank(imageSource.highRes)) {
    return null
  }

  const url = getImageByResolution(imageSource)

  return `${ENDPOINT}/${url}`
}

const imageUrl = (imageSource: ImageSource) => {
  return getImageUrl(imageSource) || NO_IMAGE
}

export class UserAvatar extends PureComponent<Props, State> {
  readonly state = {
    hasImage: true,
    initials: getUserInitials(this.props.userName),
    imageUrl: imageUrl(this.props.imageSource),
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    // we dont want to 'reset' internal state if image was not changed
    if (state.imageUrl === imageUrl(props.imageSource)) {
      return null
    }

    return {
      hasImage: true,
      initials: getUserInitials(props.userName),
      imageUrl: imageUrl(props.imageSource),
    } as State
  }

  render() {
    const { avatarSize, className, inline } = this.props
    const { hasImage, initials } = this.state

    const userAvatarClassName = classNames('user-avatar', className, { 'user-avatar--inline': inline })
    const userAvatarStyle = avatarSize
      ? { width: `${avatarSize}px`, height: `${avatarSize}px`, fontSize: `${this.calculateFontSize(avatarSize)}px` }
      : { width: '100%', height: '100%', fontSize: 'inherit' }

    if (hasImage) {
      return (
        <div className={userAvatarClassName} style={userAvatarStyle}>
          <img className="user-avatar__image" src={imageUrl(this.props.imageSource)} onError={this.handleImageError} />
        </div>
      )
    }

    return (
      <div className={userAvatarClassName} style={userAvatarStyle}>
        <div className="user-avatar__initials">{initials}</div>
      </div>
    )
  }
  private handleImageError = () => {
    this.setState({
      hasImage: false,
    })
  }

  private calculateFontSize(avatarSize: number) {
    const margin = Math.floor(avatarSize / 100 * 10)

    return Math.round((avatarSize - margin) / 2)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/user-avatar/user-avatar.component.tsx